var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSiriusLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 96,
  height: 97,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0000EB",
  d: "M0 .258h96v96H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M85.675 49.533c1.8 2.758 2.874 6.125 2.874 10.276-.116 15.325-12.8 25.717-40.085 25.717-17.068 0-35.819-5.196-37.386-25.02v-.987H36.65l-5.66 16.69 18.664-12.975 18.663 12.974L63.47 61.87c-.755-1.48-2.7-2.292-2.7-2.292-10.187-5.66-47.37-2.584-47.37-27.605 0-18.838 19.767-24.324 35.267-24.324 16.225 0 35.267 3.658 36.98 23.192v.755H56.851l-7.14-21.015-7.14 21.015H19.494l12.888 8.882c3.773-1.51 7.808-2.177 11.843-2.612a75 75 0 0 1 13.033-.262c3.657.233 7.285.755 10.855 1.597 3.222.755 6.502 1.596 9.434 3.193 3.28 1.8 6.153 4.092 8.127 7.14"
})));
export default SvgIconSiriusLogo;